/**
 * Media query breakpoints. These must be kept in sync with breakpoints defined in sass variables.
 */
export const breakpoints = {
  xs: 0,
  sm: 400,
  md: 700,
  lg: 992,
  xl: 1312,
};
